import { useState } from "react";
import SendMoneyItem from "../../components/Accounts/SendMoneyItem";
import CustomModal from "../../components/CustomModal";
import { sendingMethodsData } from "./data";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store/rootReducer";
import {
  setFirstModalOpen,
  setSecondModalOpen,
} from "../../store/accountsModal";
import { useNavigate } from "react-router-dom";
import AccountTransfer from "../AccountTransfer/FipayTransfer";

export const SendMoneyModal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { firstModalOpen, secondModalOpen } = useSelector(
    (state: RootState) => state.accountsModal
  );
  const tag = useSelector((state: RootState) => state.user?.user?.tag);

  const handleSendMoney = (index: number, route: string) => {
    switch (index) {
      case 0:
        if (tag) {
          dispatch(setFirstModalOpen(false));
          navigate(route);
        } else {
          dispatch(setFirstModalOpen(false));
          dispatch(setSecondModalOpen(true));
        }
        break;
      case 1:
        dispatch(setFirstModalOpen(false));
        navigate(route);
        break;
      case 2:
        dispatch(setFirstModalOpen(false));
        navigate(route);
        break;
      case 3:
        dispatch(setFirstModalOpen(false));
        navigate(route);
        break;
      default:
        break;
    }
  };

  const handleClose = () => {
    dispatch(setFirstModalOpen(false));
  };
  return (
    <>
      <CustomModal
        open={firstModalOpen}
        onClose={handleClose}
        header={{
          title: "Send Money",
          subtitle: "Transfer money to different users and account",
        }}
      >
        {sendingMethodsData.map((item, index) => (
          <SendMoneyItem
            icon={item.icon}
            title={item.title}
            subtitle={item.subTitle}
            index={index}
            lastIndex={sendingMethodsData.length - 1}
            onClick={() => handleSendMoney(index, item.route)}
          />
        ))}
      </CustomModal>
    </>
  );
};
